import React, { useEffect } from "react";
import CardTemplate from "../../Genericos/CardTemplate/CardTemplate";
import Dropdown from "../../Genericos/Dropdown/Dropdown";

import MultiTabPerfil from "../MultiTabPerfil/MultiTabPerfil";
import { PortalContext } from "../../../context/Provider";
import { useContext, useState } from "react";
import {
  editaPerfil,
  finalizaEdicion,
  setUserSelectEditar,
} from "../../../context/Actions/paciente/paciente";
import { wsPostEditarPaciente } from "../../../context/Actions/paciente/paciente";
import { TabsData } from "../PerfilDatosPersonales/TabsData";
import "./CardPerfil.css";
import { TabsEstilo } from "../PerfilDatosPersonales/TabsEstilo";
import { logoutRegistro } from "../../../context/Actions/registro/logoutRegistro";
import { wsGetDatosPaciente } from "../../../context/Actions/paciente/paciente";
import { dropdownFamiliares } from "../../Turnos/ListaFamiliaresDropdown/ListaFamiliaresDropdown";
import { hideModal, showModal } from "../../../context/Actions/modal/modal";
import CameraIcon from "../../../assets/images/generico/CameraIcon";
import defaultPerfil from "../../../assets/images/generico/defaultUserImage.png";
import EditarMobileIcon from "../../../assets/images/generico/EditarMobileIcon";
import { GlobalContext } from "../../../../global/context/Provider";

const CardPerfil = () => {
  const {
    pacienteDispatch,
    registroDispatch,
    pacienteState,
    listaFamiliaresState,
    modalDispatch,
  } = useContext(PortalContext);

  // Cambio de contexto
  const { authState } = useContext(GlobalContext);

  const [guardarPerfil, setGuardarPerfil] = useState(false);
  const [dtoImagenPerfil, setDtoImagenPerfil] = useState(null);
  const [inputKey, setInputKey] = useState();
  const pacienteAuth = authState?.auth?.data?.paciente;

  const [imgPerfil, setImgPerfil] = useState(
    pacienteAuth?.imagenPerfil ?? null
  );

  useEffect(() => {
    if (
      pacienteState.paciente.cambioClave !== null &&
      pacienteState.paciente.cambioClave !== undefined &&
      pacienteState.paciente.cambioClave !== "" &&
      pacienteState.paciente.cambioClave?.origen === "cambioClave"
    ) {
      setGuardarPerfil(false);
    }
  }, [pacienteState.paciente.cambioClave]);

  useEffect(() => {
    if (pacienteState.paciente.datosActualizados !== null) {
      if (pacienteState.paciente.userSelect.pacienteSeleccionado) {
        setImgPerfil(
          pacienteState.paciente.userSelect.pacienteSeleccionado.paciente
            .imagenPerfil
        );
      } else {
        setImgPerfil(pacienteState.paciente.datosActualizados.imagenPerfil);
      }
    }
  }, [pacienteState.paciente.datosActualizados]);

  useEffect(() => {
    if (pacienteState.paciente.data?.origen === "editePaciente") {
      if (pacienteState.paciente.userSelect.pacienteSeleccionado) {
        wsGetDatosPaciente(
          pacienteState.paciente.userSelect.pacienteSeleccionado.id
        )(pacienteDispatch);
      } else {
        wsGetDatosPaciente()(pacienteDispatch);
      }
    }
  // eslint-disable-next-line
  }, [pacienteState.paciente.data]);

  const dissmiss = () => {
    hideModal()(modalDispatch);
  };

  const modalCambioDeImagen = () => {
    showModal(
      "Perfil/ModalFotoPerfil/ModalFotoPerfil",
      {
        titulo: "Cambio de Foto de Perfil",
        dissmiss: dissmiss,
      },
      {},
      "centro",
      true
    )(modalDispatch);
  };

  const onEditarPerfilMobile = () => {
    if (!guardarPerfil) {
      let enablePerfilForm = true;
      editaPerfil(enablePerfilForm)(pacienteDispatch);
      setGuardarPerfil(true);
    } else {
      logoutRegistro()(registroDispatch);
      if (pacienteState.paciente.userSelect.pacienteSeleccionado) {
        wsGetDatosPaciente(
          pacienteState.paciente.userSelect.pacienteSeleccionado.id
        )(pacienteDispatch);
      } else {
        wsGetDatosPaciente()(pacienteDispatch);
      }
      finalizaEdicion()(pacienteDispatch);
      setGuardarPerfil(false);
    }
  };

  const guardarCambiosPerfil = () => {
    if (pacienteState.paciente.userSelect.pacienteSeleccionado) {
      wsPostEditarPaciente(
        pacienteState.paciente.editaPerfil.editarPaciente,
        pacienteState.paciente.userSelect.pacienteSeleccionado.id
      )(pacienteDispatch);
    } else {
      wsPostEditarPaciente(pacienteState.paciente.editaPerfil.editarPaciente)(
        pacienteDispatch
      );
    }

    finalizaEdicion()(pacienteDispatch);
    setGuardarPerfil(false);
  };

  const onPerfilFamiliaresChange = (e) => {
    const idUser = pacienteAuth?.codigo;

    if (!idUser) {
      setUserSelectEditar(false)(pacienteDispatch);
      return;
    }

    if (e !== "") {
      if (idUser === e.id) {
        // Usuario seleccionó su propio perfil
        setUserSelectEditar(false)(pacienteDispatch);
        wsGetDatosPaciente(-1, false)(pacienteDispatch); // Cargar datos del usuario principal directamente
      } else if (e.edicionPerfil && idUser !== e.id) {
        // Usuario seleccionó un familiar CON permisos de edición
        setUserSelectEditar({ id: e.id, paciente: e.paciente })(
          pacienteDispatch
        );
        wsGetDatosPaciente(e.id, false)(pacienteDispatch); // Cargar datos del familiar seleccionado DIRECTAMENTE con su ID
      } else if (!e.edicionPerfil && idUser !== e.id) {
        // Usuario seleccionó un familiar SIN permisos de edición
        showModal(
          "Perfil/ModalAlertGrupoFamiliar/ModalAlertGrupoFamiliar",
          {},
          "centro"
        )(modalDispatch);
        setUserSelectEditar(false)(pacienteDispatch);
      }
    }
  };
  return (
    <React.Fragment>
      <CardTemplate
        tituloCard={
          <div className="ptur-card-cardPefil-editar">
            <span className="ptur-card-cardPerfil-tittle">Perfil</span>
            <div>
              {!guardarPerfil ? (
                <button
                  className={`ptur-card-cardPefil-btnEditar `}
                  onClick={onEditarPerfilMobile}
                  disabled={
                    pacienteState.paciente.cambioClave === true ? true : false
                  }
                >
                  <EditarMobileIcon
                    color={
                      pacienteState.paciente.cambioClave === true
                        ? "var(--color-grey65)"
                        : "var(--color-white)"
                    }
                  />
                  <span
                    className={`ptur-card-cardPefil-txtEditar rb16m ${pacienteState.paciente.cambioClave === true
                        ? `c-grey65`
                        : `c-white`
                      }`}
                  >
                    Editar
                  </span>
                </button>
              ) : (
                <div className="ptur-card-cardPerfil-btnBox">
                  <button
                    className="ptur-card-cardPefil-btnCancelar rb18m"
                    onClick={onEditarPerfilMobile}
                  >
                    Cancelar
                  </button>
                  <button
                    className="ptur-card-cardPefil-btnGuardar rb16m"
                    onClick={guardarCambiosPerfil}
                  >
                    Guardar
                  </button>
                </div>
              )}
            </div>
          </div>
        }
        // rotated={showFormPerfil}
        // onClickVerPerfil={onVerPerfilMobile}
        // dropdownPerfilMobile={animationDropdown}
        bodyCard={
          <React.Fragment>
            <div className="ptur-card-cardPefil-dropdown">
              <Dropdown
                onChange={onPerfilFamiliaresChange}
                campoCodigo="id"
                descripcion="nombre"
                valor={
                  !pacienteState.paciente.userSelect.pacienteSeleccionado
                    ? pacienteAuth?.codigo ?? ""
                    : pacienteState.paciente.userSelect.pacienteSeleccionado.id
                }
                datos={dropdownFamiliares(
                  listaFamiliaresState,
                  authState,
                  "EditarPerfil"
                )}
              />
            </div>
            <div className="ptur-card-cardPefil-container">
              <div className="ptur-perfil-header-imgNombre-img">
                <img
                  id="ptur-perfil-datos-foto"
                  src={
                    imgPerfil
                      ? `data:image/jpeg;base64,${imgPerfil}`
                      : defaultPerfil
                  }
                  alt="Perfil"
                />
                <label htmlFor="input2" className="image-upload2 pointer">
                  <div
                    className={`ptur-cardperfil-header-cameraIcon-box ${pacienteState.paciente.cambioClave === true ||
                        pacienteState.paciente.editaPerfil.estado === true
                        ? "bgc-grey65"
                        : "bgc-latex30"
                      } pointer`}
                    htmlFor="input2"
                    onClick={modalCambioDeImagen}
                  >
                    <div
                      className="ptur-cardperfil-header-cameraIcon-icon"
                      htmlFor="input2"
                    >
                      <CameraIcon />
                    </div>
                  </div>
                </label>
              </div>
              <div>
                <MultiTabPerfil tabs={TabsData} estilos={TabsEstilo} />
              </div>
            </div>
          </React.Fragment>
        }
      />
    </React.Fragment>
  );
};

export default CardPerfil;
